export type GtmPaymentType = 'card' | 'direct debit';

export type GtmDeliveryType = 'swift' | 'mTicket';

export type GtmEventName =
  | 'selectTicket'
  | 'ticketSelector'
  | 'ticketResults'
  | 'login'
  | 'yourDetails'
  | 'addToBasket'
  | 'removeFromBasket'
  | 'ticketReceipt'
  | 'loginRegister';

export type GtmBasketEventName = 'addToBasket' | 'removeFromBasket';

export interface GtmEventEcommerceItem {
  delivery?: GtmDeliveryType;
  item_name: string;
  item_id: string;
  price: number;
  discounted_price?: number;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_category3: string;
  item_category4: string;
  item_category5: string;
  item_variant?: string;
  quantity: number;
  currency: string;
  discount: number;
  coupon?: string;
  couponCampaign?: string;
}

export interface GtmEventEcommerce {
  value?: number;
  currency?: string;
  transaction_id?: string;
  coupon?: string;
  shipping?: string;
  discounted_value?: number;
  total_discount?: number;
  paymentType?: string;
  items: GtmEventEcommerceItem[];
}

export interface GtmEventUser {
  loginState?: boolean;
  id?: string;
  loginMethod: 'email';
}

export interface GtmPageDetails {
  title: string;
  url: string;
}

export interface GtmSiteDetails {
  environment: string;
  versionNo: 'v1.0';
}

export interface GtmEvent {
  event: GtmEventName;
  user: GtmEventUser;
  site: GtmSiteDetails;
  page: GtmPageDetails;
  ecommerce?: GtmEventEcommerce;
}

export interface GtmRouteDetails {
  page: GtmPageDetails;
  event?: GtmEventName;
}
